export default __webpack_public_path__ + "static/media/coolcats.ff8920ee.png";